import '../App.css';

function ErasTourTermsOfUse() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Terms of Use</h1>
        <p className="app-name">Eras Tour: Find Surprise Songs</p>
        <p className="last-updated">Last Updated: January 2025</p>

        <section>
          <h2>Acceptance of Terms</h2>
          <p>
            By downloading, installing, or using Eras Tour Surprise Songs ("the App"),
            you agree to be bound by these Terms of Use. If you do not agree to these
            terms, please do not use the App.
          </p>
        </section>

        <section>
          <h2>Description of Service</h2>
          <p>
            The App provides a searchable database of surprise songs performed during
            Taylor Swift's Eras Tour concerts. Users can browse, search, and save their
            favorite songs for reference.
          </p>
        </section>

        <section>
          <h2>User Conduct</h2>
          <p>You agree to:</p>
          <ul>
            <li>Use the App only for lawful purposes</li>
            <li>Not attempt to reverse engineer or modify the App</li>
            <li>Not use the App to distribute unauthorized content</li>
            <li>Not interfere with the App's operation or security</li>
          </ul>
        </section>

        <section>
          <h2>Intellectual Property</h2>
          <p>
            The App's design, code, and original content are owned by Durianbit.
            Song titles, artist names, and concert information are provided for
            informational purposes only and remain the property of their respective owners.
          </p>
        </section>

        <section>
          <h2>Disclaimer of Warranties</h2>
          <p>
            The App is provided "as is" without warranties of any kind, either express
            or implied. We do not guarantee that:
          </p>
          <ul>
            <li>The App will be error-free or uninterrupted</li>
            <li>All information is completely accurate or up-to-date</li>
            <li>The App will meet your specific requirements</li>
          </ul>
        </section>

        <section>
          <h2>Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, Durianbit shall not be liable for
            any indirect, incidental, special, or consequential damages arising from
            your use of the App.
          </p>
        </section>

        <section>
          <h2>Changes to the App</h2>
          <p>
            We reserve the right to modify, suspend, or discontinue the App at any
            time without notice. We may also update these Terms of Use from time to time.
          </p>
        </section>

        <section>
          <h2>Termination</h2>
          <p>
            We may terminate or suspend your access to the App at any time, without
            prior notice, for conduct that we believe violates these Terms of Use or
            is harmful to other users.
          </p>
        </section>

        <section>
          <h2>Governing Law</h2>
          <p>
            These Terms of Use shall be governed by and construed in accordance with
            the laws of Singapore, without regard to its conflict of law provisions.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>
            If you have questions about these Terms of Use, please contact us at:{' '}
            <a href="mailto:hello@durianbit.com">hello@durianbit.com</a>
          </p>
        </section>

        <section className="disclaimer">
          <h2>Important Notice</h2>
          <p>
            <strong>
              This app is not affiliated with, endorsed by, or associated with Taylor Swift,
              TAS Rights Management, LLC, or the Eras Tour in any way.
            </strong>{' '}
            All song information and tour data is compiled from publicly available sources
            for informational purposes only. Taylor Swift, The Eras Tour, and related marks
            are trademarks of their respective owners. YouTube is a trademark of Google LLC.
          </p>
        </section>
      </div>
    </div>
  );
}

export default ErasTourTermsOfUse;
